/** `/opcenter/live-status` response: no live incidents. */
const STATUS_PAGE_RESPONSE = {
  page: {
    id: "mock-status-page",
    name: "Spirii Status",
    url: "https://status.spirii.com",
    time_zone: "UTC",
    updated_at: "2026-07-16T10:00:00.000Z",
  },
  status: {
    indicator: "none",
    description: "All Systems Operational",
  },
};

export { STATUS_PAGE_RESPONSE };
